module.exports = __webpack_public_path__ + "58bb5742.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/ic_exclamation.png
// module id = 1256
// module chunks = 0 1